import type { ThemeConfig } from "antd";

export const vaultTheme: ThemeConfig = {
  token: {
    // Primary palette
    colorPrimary: "#0F6E56",
    colorSuccess: "#10B981",
    colorWarning: "#F59E0B",
    colorError: "#EF4444",
    colorInfo: "#3B82F6",

    // Border radius - more rounded for modern feel
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 6,

    // Typography
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 14,
    fontSizeHeading1: 32,
    fontSizeHeading2: 26,
    fontSizeHeading3: 22,
    fontWeightStrong: 600,

    // Colors
    colorBgContainer: "#ffffff",
    colorBgLayout: "#F9FAFB",
    colorBgElevated: "#ffffff",
    colorBorder: "rgba(0, 0, 0, 0.06)",
    colorBorderSecondary: "rgba(0, 0, 0, 0.04)",

    // Shadows
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06)",
    boxShadowSecondary: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)",

    // Motion
    motionDurationSlow: "0.3s",
    motionDurationMid: "0.2s",
    motionDurationFast: "0.1s",
  },
  components: {
    Table: {
      headerBg: "#F9FAFB",
      rowHoverBg: "rgba(15, 110, 86, 0.03)",
      rowSelectedBg: "rgba(15, 110, 86, 0.04)",
      rowSelectedHoverBg: "rgba(15, 110, 86, 0.06)",
      headerSortActiveBg: "#F3F4F6",
      borderColor: "rgba(0, 0, 0, 0.04)",
    },
    Select: {
      controlHeight: 42,
      borderRadiusLG: 10,
      optionSelectedBg: "rgba(15, 110, 86, 0.06)",
      optionActiveBg: "#F5F5F5",
    },
    Card: {
      paddingLG: 20,
      boxShadowTertiary: "0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06)",
    },
    Button: {
      primaryShadow: "0 2px 4px rgba(15, 110, 86, 0.2)",
      defaultShadow: "none",
      borderRadiusLG: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      fontWeight: 500,
    },
    Modal: {
      borderRadiusLG: 16,
      paddingContentHorizontalLG: 28,
    },
    Menu: {
      itemBorderRadius: 10,
      itemMarginInline: 12,
      itemPaddingInline: 16,
      itemHeight: 44,
      iconMarginInlineEnd: 14,
    },
    Input: {
      controlHeight: 42,
      borderRadiusLG: 10,
    },
    Tag: {
      borderRadiusSM: 6,
    },
    Dropdown: {
      borderRadiusLG: 12,
      paddingBlock: 6,
    },
    Avatar: {
      borderRadius: 10,
    },
  },
};
